import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageWithTitle } from "@common/components/PageLayout/PageWithTitle";
import { HomeTab } from "./HomeTab";
import { ReportsTab } from "./ReportsTab";
import { StipendsTab } from "./StipendsTab";
import { StatsTab, useCurrentStatsTab } from "./utils/useCurrentStatsTab";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const TABS = [
  {
    value: StatsTab.Home,
    title: "Home",
    content: <HomeTab />,
  },
  {
    value: StatsTab.Reports,
    title: "Reports",
    content: <ReportsTab />,
  },
  {
    value: StatsTab.Stipends,
    title: "Stipends",
    content: <StipendsTab />,
  },
];

export const StatsPage = () => {
  const { tab, setTab } = useCurrentStatsTab();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const tabFromSearchParams = searchParams.get("tab");
    if (
      tabFromSearchParams &&
      Object.values(StatsTab).includes(tabFromSearchParams as StatsTab)
    ) {
      setTab(tabFromSearchParams as StatsTab);
    }
  }, [searchParams, setTab]);

  useEffect(() => {
    setSearchParams({ tab });
  }, [tab, setSearchParams]);

  return (
    <PageWithTitle title="Statistics">
      <Tabs value={tab} onValueChange={(newTab) => setTab(newTab as StatsTab)}>
        <TabsList>
          {TABS.map((t) => (
            <TabsTrigger key={t.value} value={t.value}>
              {t.title}
            </TabsTrigger>
          ))}
        </TabsList>
        {TABS.map((t) => (
          <TabsContent key={t.value} value={t.value} className="mt-4">
            {t.content}
          </TabsContent>
        ))}
      </Tabs>
    </PageWithTitle>
  );
};
